/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable, OnDestroy } from '@angular/core';

import { catchError, map, of } from 'rxjs';

import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';
import { JournodexRegionsService } from '../../Journodex/services/journodex-regions.service';
import { ProminenceLockerService } from '../../Misc/services/prominence-locker.service';
import { UserPreferencesService } from '../../../Account/UserPreferences/services/user-preferences.service';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { CurrencyConversionService } from '../../../Core/Users/services/currency-conversion.service';
import { MonitorConfigService } from '../../MonitorShared/services/monitor-config.service';
import { ReportsGeneralDataMapperService } from './reports-general-data-mapper.service';
import { userAppPreferencesDefault } from '../../../Core/Users/data/user-app-preferences-default';


@Injectable()
export class ReportsSeriesDataMapperService extends ReportsGeneralDataMapperService implements OnDestroy {

    constructor(
        public localizationService: LocalizationService,
        public journodexSearchService: JournodexRegionsService,
        public prominenceBlockerService: ProminenceLockerService,
        public userPreferencesService: UserPreferencesService,
        public currentUserStateService: CurrentUserStateService,
        public monitorConfigService: MonitorConfigService,
        public currencyConversionService: CurrencyConversionService
    ) {
        super(
            localizationService,
            journodexSearchService,
            currentUserStateService,
            currencyConversionService
        );

        this.hasTiktok = false;
        this.subscriptions.push(
            this.prominenceBlockerService.prominenceStatus$.subscribe(status => {
                this.prominenceStatus = status;
            }),
            this.monitorConfigService.getAvailableMediaTypes().subscribe(mediaTypes => {
                this.hasTiktok = mediaTypes.includes(MediaTypeEnum.TIKTOK);
            }),
            this.userPreferencesService.getUserAppPreferences().pipe(
                map(userAppPrefs => userAppPrefs.reportsPrefs.defaultChartColors),
                catchError(() => of(userAppPreferencesDefault.reportsPrefs.defaultChartColors))
            ).subscribe(userChartColors => {
                this.userChartColors = userChartColors;
            }),
        );
    }
}
